var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PaletteChip,{attrs:{"id_palette":(!!_vm.model[_vm.field])?1:2}},[_vm._v(_vm._s((!!_vm.model[_vm.field])?_vm.labelArchived:_vm.labelActual))])
}
var staticRenderFns = []

export { render, staticRenderFns }